export default __webpack_public_path__ + "static/media/doodle2.662017c9.png";